import { combineReducers } from 'redux';
import { createStore, applyMiddleware, compose } from 'redux';
import reduxThunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
//import logger from 'redux-logger';

import WP from 'WP';

/*
|--------------------------------------------------------------------------
|  MENUS REDUCER
|--------------------------------------------------------------------------
|
*/
const menusReducer = (state = { no: {}, en: {} }, action) => {
    switch(action.type) {
        case 'ADD_MENU_TO_STORE' : 
            return {...state, 
                        [WP.lang]: {...state[WP.lang], 
                            [action.payload.location]: action.payload.menu }};
        default :
            return state;
    }
}
// "ADD_MENU_TO_STORE" action is dispatched by api.js

/*
|--------------------------------------------------------------------------
|  CURRENT VIEW REDUCER
|--------------------------------------------------------------------------
| holds currently displayed page / post
*/
const currentViewReducer = (state = null, action) => {
    switch(action.type) {
        case 'SET_CURRENT_VIEW' : 
            return action.payload || null;
        default :
            return state;
    }
}

export const setCurrentView = view => {
    return { 
        type: 'SET_CURRENT_VIEW', 
        payload: view 
    };
}

/*
|--------------------------------------------------------------------------
|  PAGES REDUCER
|--------------------------------------------------------------------------
|
*/
const pagesReducer = (state = { 
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
    }, action) => {
        switch(action.type) {
            case 'SET_PAGES' : 
                return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
            case 'SET_PAGES_ALL_LOADED_FLAG' : 
                return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
            case 'SET_PAGES_LATEST_LOADED_FLAG' : 
                return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
            default :
                return state;
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance


const postsReducer = (state = { 
                        posts: { no: [], en: [] }, 
                        allLoaded: { no: false, en: false }, 
                        latestLoaded: { no: false, en: false } 
                    }, action) => {
    switch(action.type) {
        case 'SET_POSTS' : 
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_POSTS_ALL_LOADED_FLAG' : 
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_POSTS_LATEST_LOADED_FLAG' : 
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default :
            return state;
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const accommodationsReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_ACCOMMODATION' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_ACCOMMODATION_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_ACCOMMODATION_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const adventuresReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_ADVENTURES' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_ADVENTURES_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_ADVENTURES_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const diningReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_DINING' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_DINING_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_DINING_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const eventsReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_EVENTS' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_EVENTS_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_EVENTS_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const rentalsReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_RENTALS' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_RENTALS_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_RENTALS_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const rentalTypesReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_RENTAL_TYPES' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_RENTAL_TYPES_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_RENTAL_TYPES_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

const conferenceVenuesReducer = (state = {
    posts: { no: [], en: [] }, 
    allLoaded: { no: false, en: false }, 
    latestLoaded: { no: false, en: false } 
}, action) => {
    switch (action.type) {
        case 'SET_CONFERENCE_VENUES' :
            return { ...state, posts: { ...state.posts, [WP.lang]: action.payload } };
        case 'SET_CONFERENCE_VENUES_ALL_LOADED_FLAG' :
            return { ...state, allLoaded: { ...state.allLoaded, [WP.lang]: action.payload } };
        case 'SET_CONFERENCE_VENUES_LATEST_LOADED_FLAG' :
            return { ...state, latestLoaded: { ...state.latestLoaded, [WP.lang]: action.payload } };
        default:
            return state
    }
}
// actions are not required - they are dispatched directly from PostFetcher instance

/*
|--------------------------------------------------------------------------
|  OVERLAY REDUCER
|--------------------------------------------------------------------------
*/
const overlayReducer = (state = '', action) => {
    switch(action.type) {
        case 'SET_OVERLAY_VALUE' : 
            return {...state, ...action.payload} || '';
        default :
            return state;
    }
}

export const setOverlayValue = string => {
    return { 
        type: 'SET_OVERLAY_VALUE', 
        payload: string 
    };
}

/*
|--------------------------------------------------------------------------
|  BACKDROP REDUCER
|--------------------------------------------------------------------------
*/
const backdropReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_BACKDROP_VALUE' : 
            return action.payload || false;
        default :
            return state;
    }
}

export const setBackdropValue = bool => {
    return { 
        type: 'SET_BACKDROP_VALUE', 
        payload: bool 
    };
}

/*
|--------------------------------------------------------------------------
|  INPUT BOX VISIBILITY REDUCER
|--------------------------------------------------------------------------
*/
const inputBoxVisibilityReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_INPUT_BOX_VISIBILITY' : 
            return action.payload || false;
        default :
            return state;
    }
}

export const setInputBoxVisibility = bool => {
    return { 
        type: 'SET_INPUT_BOX_VISIBILITY', 
        payload: bool 
    };
}

/*
|--------------------------------------------------------------------------
|  SCROLLBARWIDTH REDUCER
|--------------------------------------------------------------------------
*/
const scrollbarWidthReducer = (state = 0, action) => {
    switch(action.type) {
        case 'SET_SCROLLBAR_WIDTH' : 
        return action.payload || 0;
        default :
            return state;
    }
}

export const setScrollbarWidth = number => {
    return { 
        type: 'SET_SCROLLBAR_WIDTH',
        payload: number 
    };
}

/*
|--------------------------------------------------------------------------
|  IMAGE GALLERY REDUCER
|--------------------------------------------------------------------------
*/
const imageGalleryReducer = (state = [], action) => {
    switch(action.type) {
        case 'SET_IMAGE_GALLERY' : 
        return action.payload || [];
        default :
            return state;
    }
}

export const setImageGallery = array => {
    return { 
        type: 'SET_IMAGE_GALLERY',
        payload: array 
    };
}

/*
|--------------------------------------------------------------------------
|  HEADER TOP PADDING REDUCER
|--------------------------------------------------------------------------
*/
const headerTopPaddingReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_HEADER_PADDING' : 
        return action.payload || false;
        default :
            return state;
    }
}

export const setHeaderTopPadding = bool => {
    return { 
        type: 'SET_HEADER_PADDING',
        payload: bool 
    };
}

/*
|--------------------------------------------------------------------------
|  NIGHT MODE REDUCER
|--------------------------------------------------------------------------
*/
const nightModeReducer = (state = false, action) => {
    switch(action.type) {
        case 'SET_NIGHT_MODE' : 
        return action.payload || false;
        default :
            return state;
    }
}

export const setNightMode = bool => {
    return { 
        type: 'SET_NIGHT_MODE',
        payload: bool 
    };
}

/*
|--------------------------------------------------------------------------
|  AVAILABILITY REDUCER
|--------------------------------------------------------------------------
*/
const availabilityReducer = (state = {
    fromDate: null,
    toDate: null,
    numPersons: '',
    numRooms: '',
    hotels: [],
    searched: false,
    prefillForm: false
}, action) => {
    switch(action.type) {
        case 'SET_DATE_RANGE' :
            return {
                ...state,
                ...{
                    fromDate: action.payload.from,
                    toDate: action.payload.to,
                }
            };
        case 'SET_NUM_ROOMS' :
            return {
                ...state,
                ...{
                    numRooms: action.payload
                }
            };
        case 'SET_NUM_PERSONS' :
            return {
                ...state,
                ...{
                    numPersons: action.payload
                }
            };
        case 'RESET_SEARCHED_BOOLEAN':
            return {
                ...state,
                ...{
                    searched: false,
                    fromDate: null,
                    toDate: null,
                    numPersons: '',
                    numRooms: '',
                    hotels: [],
                }
            };
        case 'SET_HOTEL_RESULTS' :
            return {    
                ...state,
                ...{
                    hotels: action.payload,
                    searched: true,
                }
            };
        case 'SET_PREFILL_FORM' :
            return {
                ...state,
                ...{
                    prefillForm: action.payload
                }
            }
        default :
            return state;
    }
}

export const setDateRange = (from, to) => {
    return {
        type: 'SET_DATE_RANGE',
        payload: { from, to }
    };
}

export const setNumRooms = rooms => {
    return {
        type: 'SET_NUM_ROOMS',
        payload: rooms
    };
}

export const setNumPersons = persons => {
    return {
        type: 'SET_NUM_PERSONS',
        payload: persons
    };
}

export const setHotelResults = results => {
    return {
        type: 'SET_HOTEL_RESULTS',
        payload: results
    };
}

export const resetSearchedBoolean = () => {
    return {
        type: 'RESET_SEARCHED_BOOLEAN',
        payload: false
    };
}

export const setPrefillForm = bool => {
    return { 
        type: 'SET_PREFILL_FORM', 
        payload: bool 
    };
}



/*
|--------------------------------------------------------------------------
|  BOOKING CART REDUCER
|--------------------------------------------------------------------------
*/
const bookingReducerDefaults = {
    acceptedTerms: false,
    acceptedNewsletter: false,
    emailValidated: false,
    validationPending: false,
    customer: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        address: '',
        company: '',
        city: '',
        zipCode: '',
        mobile: '',
        emailValidationToken: '',
    },
    reservations: [],
    orderGroupData: {},
    firstReservationTime: null,
};

const bookingReducer = (state = bookingReducerDefaults, action) => {
    switch(action.type) {
        case 'RESET_CUSTOMER_INFO':
            return {
                ...state,
                ...bookingReducerDefaults,
            };
        case 'ADD_RESERVATION':
            return {
                ...state,
                ...{
                    reservations: [...state.reservations, action.payload],
                    orderGroupData: {},
                    firstReservationTime: (typeof state.firstReservationTime === undefined || state.firstReservationTime === null) ? new Date() : state.firstReservationTime,
                }
            };
        case 'UPDATE_RESERVATION':
            return {
                ...state,
                ...{
                    reservations: state.reservations.map(r => {
                        r.reservationTime = action.payload.reservationId === r.reservationId ? new Date() : r.reservationTime;
                        return r;
                    })
                }
            };
        case 'REMOVE_RESERVATION':
            return {
                ...state,
                ...{
                    reservations: state.reservations.filter((r, i) => i !== action.payload)
                }
            };
        case 'EMPTY_RESERVATIONS':
            return {
                ...state,
                ...{
                    reservations: [],
                    firstReservationTime: null,
                }
            };
        case 'SET_CUSTOMER_INFO' :
            return {
                ...state,
                ...{
                    customer: {
                        ...state.customer,
                        ...action.payload
                    }
                }
            };
        case 'START_EMAIL_VALIDATION':
            return {
                ...state,
                ...{
                    emailValidated: false,
                    validationPending: true,
                }
            };
        case 'INVALID_EMAIL_VALIDATION':
            return {
                ...state,
                ...{
                    emailValidated: false,
                    validationPending: false,
                }
            };
        case 'SUCCESSFUL_EMAIL_VALIDATION':
            return {
                ...state,
                ...{
                    emailValidated: true,
                    validationPending: false,
                }
            };
        case 'SET_ACCEPTED_TERMS':
            return {
                ...state,
                ...{
                    acceptedTerms: action.payload
                }
            };
        case 'SET_ACCEPTED_NEWSLETTER':
            return {
                ...state,
                ...{
                    acceptedNewsletter: action.payload
                }
            };
        case 'SET_ORDER_GROUP_DATA':
            return {
                ...state,
                ...{
                    orderGroupData: action.payload,
                    reservations: [],
                    firstReservationTime: null,
                }
            };
        default :
            return state;
    }
}

export const addReservation = reservation => {
    return {
        type: 'ADD_RESERVATION',
        payload: reservation
    };
}

export const updateReservation = reservation => {
    return {
        type: 'UPDATE_RESERVATION',
        payload: reservation
    };
}

export const removeReservation = reservationIndex => {
    return {
        type: 'REMOVE_RESERVATION',
        payload: reservationIndex
    };
}

export const emptyReservations = () => {
    return {
        type: 'EMPTY_RESERVATIONS',
        payload: null
    };
}

export const resetCustomerInfo = () => {
    return {
        type: 'RESET_CUSTOMER_INFO',
        payload: null
    };
}

export const setCustomerInfo = data => {
    return {
        type: 'SET_CUSTOMER_INFO',
        payload: data
    };
}

export const startEmailValidation = bool => {
    return {
        type: 'START_EMAIL_VALIDATION',
        payload: bool
    };
}

export const invalidEmailValidation = bool => {
    return {
        type: 'INVALID_EMAIL_VALIDATION',
        payload: bool
    };
}

export const successFullEmailValidation = bool => {
    return {
        type: 'SUCCESSFUL_EMAIL_VALIDATION',
        payload: bool,
    }
}

export const setAcceptedTerms = bool => {
    return {
        type: 'SET_ACCEPTED_TERMS',
        payload: bool
    };
}

export const setAcceptedNewsletter = bool => {
    return {
        type: 'SET_ACCEPTED_NEWSLETTER',
        payload: bool
    };
}

export const setOrderGroupData = data => {
    return {
        type: 'SET_ORDER_GROUP_DATA',
        payload: data
    };
}

/*
|--------------------------------------------------------------------------
|  FAVORITES REDUCER
|--------------------------------------------------------------------------
*/
const favoritesReducer = (state = {
    hotels: [],
    adventures: [],
    dining: [],
    events: [],
    conference_venues: [],
}, action) => {
    switch(action.type) {
        case 'SET_FAVORITE_HOTEL' :
            return {
                ...state,
                ...{
                    hotels: [ ...state.hotels, action.payload]
                }
            };
        case 'SET_FAVORITE_ADVENTURE' :
            return {
                ...state,
                ...{
                    adventures: [ ...state.adventures, action.payload]
                }
            };
        case 'SET_FAVORITE_DINING' :
            return {
                ...state,
                ...{
                    dining: [ ...state.dining, action.payload]
                }
            };
        case 'SET_FAVORITE_EVENT' :
            return {
                ...state,
                ...{
                    events: [ ...state.events, action.payload]
                }
            };
        case 'SET_FAVORITE_CONFERENCE_VENUE' :
            return {
                ...state,
                ...{
                    conference_venues: [ ...state.conference_venues, action.payload]
                }
            };
        case 'REMOVE_FAVORITE_HOTEL' :
            return {
                ...state,
                ...{
                    hotels: state.hotels.filter(hotelId => hotelId !== action.payload)
                }
            };
        case 'REMOVE_FAVORITE_ADVENTURE' :
            return {
                ...state,
                ...{
                    adventures: state.adventures.filter(adventureId => adventureId !== action.payload)
                }
            };
        case 'REMOVE_FAVORITE_DINING' :
            return {
                ...state,
                ...{
                    dining: state.dining.filter(diningId => diningId !== action.payload)
                }
            };
        case 'REMOVE_FAVORITE_EVENT' :
            return {
                ...state,
                ...{
                    events: state.events.filter(eventId => eventId !== action.payload)
                }
            };
        case 'REMOVE_FAVORITE_CONFERENCE_VENUE' :
            return {
                ...state,
                ...{
                    conference_venues: state.conference_venues.filter(venueId => venueId !== action.payload)
                }
            };
        default :
            return state;
    }
}

export const setFavoriteHotel = hotelId => {
    return {
        type: 'SET_FAVORITE_HOTEL',
        payload: hotelId
    };
}

export const setFavoriteAdventure = adventureId => {
    return {
        type: 'SET_FAVORITE_ADVENTURE',
        payload: adventureId
    };
}

export const setFavoriteDining = diningId => {
    return {
        type: 'SET_FAVORITE_DINING',
        payload: diningId
    };
}

export const setFavoriteEvent = eventId => {
    return {
        type: 'SET_FAVORITE_EVENT',
        payload: eventId
    };
}

export const setFavoriteConferenceVenue = venueId => {
    return {
        type: 'SET_FAVORITE_CONFERENCE_VENUE',
        payload: venueId
    };
}

export const removeFavoriteHotel = hotelId => {
    return {
        type: 'REMOVE_FAVORITE_HOTEL',
        payload: hotelId

    };
}

export const removeFavoriteAdventure = adventureId => {
    return {
        type: 'REMOVE_FAVORITE_ADVENTURE',
        payload: adventureId
    };
}

export const removeFavoriteDining = diningId => {
    return {
        type: 'REMOVE_FAVORITE_DINING',
        payload: diningId
    };
}

export const removeFavoriteEvent = eventId => {
    return {
        type: 'REMOVE_FAVORITE_EVENT',
        payload: eventId
    };
}

export const removeFavoriteConferenceVenue = venueId => {
    return {
        type: 'REMOVE_FAVORITE_CONFERENCE_VENUE',
        payload: venueId

    };
}

/*
|--------------------------------------------------------------------------
|  COMBINED REDUCERS
|--------------------------------------------------------------------------
*/
const reducers = combineReducers({
    menus: menusReducer,
    currentView: currentViewReducer,
    pages: pagesReducer,
    posts: postsReducer,
    accommodation: accommodationsReducer,
    adventures: adventuresReducer,
    dining: diningReducer,
    events: eventsReducer,
    rentals: rentalsReducer,
    rental_types: rentalTypesReducer,
    conference_venues: conferenceVenuesReducer,
    overlayValue: overlayReducer,
    headerTopPadding: headerTopPaddingReducer,
    nightMode: nightModeReducer,
    backdropValue: backdropReducer,
    inputBoxVisibility: inputBoxVisibilityReducer,
    scrollbarWidth: scrollbarWidthReducer,
    availability: availabilityReducer,
    booking: bookingReducer,
    favorites: favoritesReducer,
    imageGallery: imageGalleryReducer,
});

/*
|--------------------------------------------------------------------------
|  Store
|--------------------------------------------------------------------------
*/
const persistConfig = {
    key: WP ? WP.theme_name : '-',
    storage,
    blacklist: ['currentView', 'menus', 'accommodation', 'adventures', 'dining', 'events', 'rentals', 'rental_types', 'conferenceVenues', 'imageGallery', 'overlayValue', 'headerTopPadding', 'backdropValue', 'inputBoxVisibility'],
    whitelist: ['availability', 'booking', 'favorites'],
}

export const store = createStore(
    persistReducer(persistConfig, reducers), 
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), 
    compose(
        applyMiddleware(reduxThunk), 
        //applyMiddleware(logger)
    )
);

export const persistor = persistStore(store);

export const maybePurgeStore = persistor => {

    if(!WP) return;

    if(process.env.NODE_ENV === 'development') {
        // alweys use "fresh" store when on localhost
        persistor.purge();
        //console.log('store cache flushed');
    } else {
        const currentPersistorKey = document.body.getAttribute('data-persistor-key');
        const savedPersistorKey = window.localStorage.getItem(WP.theme_name+'-persistorKey');

        // 1. persistor key is not yet saved (first time visist)
        if(!savedPersistorKey) {
            console.log('Persistor key not found. Setting persistor key to "'+currentPersistorKey+'"');
            window.localStorage.setItem(WP.theme_name+'-persistorKey', currentPersistorKey);
        }

        // 2. persistor key is already saved and it matches current persistor key
        if(savedPersistorKey && savedPersistorKey === currentPersistorKey) {
            console.log('Current persistor key "'+currentPersistorKey+'" matches saved persistor key "'+savedPersistorKey+'"');
        }
        // 3. persistor key is already saved and it DOES NOT match current persistor key
        if(savedPersistorKey && savedPersistorKey !== currentPersistorKey) {
            console.log('Current persistor key "'+currentPersistorKey+'" DOES NOT MATCH saved persistor key "'+savedPersistorKey+'" - purging store...');
            // purge store
            persistor.purge();
            // update persistor key
            window.localStorage.setItem(WP.theme_name+'-persistorKey', currentPersistorKey);
        }
    }
}
